import type { App } from 'vue'
import { useThemeStore } from '@/core/stores/useThemeStore'

/**
 * Theme plugin pro inicializaci výchozího tématu aplikace
 *
 * Tento plugin inicializuje theme store a aplikuje výchozí preset
 * po vytvoření Pinia instance.
 */
export const themePlugin = {
  install(app: App) {
    // Theme store musí být inicializován po Pinia
    // Proto používáme app.runWithContext pro správný context
    app.runWithContext(() => {
      const themeStore = useThemeStore()
      themeStore.applyThemePreset('firegold')
    })
  }
}
